module.exports = __webpack_public_path__ + "static/media/Distinction Bias.8c7152a5.jpg";